import IconPlus from "./IconPlus";
export default IconPlus;
